import { render, staticRenderFns } from "./AmazeExtraAttributesEditor.vue?vue&type=template&id=f500f5ac&scoped=true"
import script from "./AmazeExtraAttributesEditor.vue?vue&type=script&lang=js"
export * from "./AmazeExtraAttributesEditor.vue?vue&type=script&lang=js"
import style0 from "./AmazeExtraAttributesEditor.vue?vue&type=style&index=0&id=f500f5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f500f5ac",
  null
  
)

export default component.exports